import { Base } from 'src/api/Base'

export class DealerAPI extends Base {
  static get entity() {
    return 'dealer'
  }

  static async getList() {
    const params = {
      ...this.datepicker,
    }
    const { data } = await this.request().get(`/${this.entity}/list`, {
      params,
    })

    return data
  }
}
